'use strict';

angular.module('msSleep').filter('sleepQualityToIcon', function () {
  return function (input) {
    switch (input) {
      case 'VERY_POOR':
        return 0;
      case 'POOR':
        return 1;
      case 'FAIR':
        return 2;
      case 'GOOD':
        return 3;
      case 'VERY_GOOD':
        return 4;
      default:
        return 2;
    }
  };
});